var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M8.167 12.25H5.833M10.5 4.667a3.5 3.5 0 1 0-7 0c0 1.802-.455 3.036-.963 3.853-.428.688-.642 1.033-.635 1.129.01.106.032.147.117.21.078.058.427.058 1.124.058h7.714c.697 0 1.046 0 1.124-.058.085-.063.108-.104.117-.21.007-.096-.207-.44-.635-1.13-.508-.816-.963-2.05-.963-3.852"
  })));
};
export default SvgBell;